// Time formatting helpers — minutes-from-midnight style + relative copy.
// Used by DayRibbon, TrackCards, DayTimeline. Locale-aware via runtimeLocale().

import { runtimeLocale } from "./i18n/runtimeLocale";

export function minutesFromMidnight(d: Date): number {
  return d.getHours() * 60 + d.getMinutes();
}

export function hm(min: number): string {
  const h24 = Math.floor(min / 60);
  const m = min % 60;
  const mm = String(m).padStart(2, "0");
  const h = ((h24 + 11) % 12) + 1;
  if (runtimeLocale() === "zh") {
    return `${h24 < 12 ? "上午" : "下午"}${h}:${mm}`;
  }
  return `${h}:${mm}${h24 < 12 ? "am" : "pm"}`;
}

export function hmShort(min: number): string {
  const h24 = Math.floor(min / 60);
  const m = min % 60;
  const mm = String(m).padStart(2, "0");
  if (runtimeLocale() === "zh") {
    return `${h24}:${mm}`;
  }
  const h = ((h24 + 11) % 12) + 1;
  const ap = h24 < 12 ? "a" : "p";
  return m === 0 ? `${h}${ap}` : `${h}:${mm}${ap}`;
}

export function durStr(mins: number): string {
  const zh = runtimeLocale() === "zh";
  if (mins < 1) return zh ? "0分钟" : "0m";
  if (mins < 60) return zh ? `${Math.round(mins)}分钟` : `${Math.round(mins)} min`;
  const h = Math.floor(mins / 60);
  const m = Math.round(mins % 60);
  if (zh) return m ? `${h}小时${m}分钟` : `${h}小时`;
  return m ? `${h}h ${m}m` : `${h}h`;
}

export function relFuture(nowMin: number, evtMin: number): string {
  const zh = runtimeLocale() === "zh";
  const d = evtMin - nowMin;
  if (d <= 5) return zh ? "马上" : "now";
  if (d < 60) return zh ? `${d}分钟后` : `in ${d} min`;
  if (d < 120) return zh ? `1小时${d - 60}分钟后` : `in 1h ${d - 60}m`;
  return zh ? `${(d / 60).toFixed(1)}小时后` : `in ${(d / 60).toFixed(1)}h`;
}

export function relPast(nowMin: number, evtMin: number): string {
  const zh = runtimeLocale() === "zh";
  const d = nowMin - evtMin;
  if (d < 1) return zh ? "刚刚" : "just now";
  if (d < 60) return zh ? `${d}分钟前` : `${d} min ago`;
  if (d < 120) return zh ? `1小时${d - 60}分钟前` : `1h ${d - 60}m ago`;
  return zh ? `${(d / 60).toFixed(1)}小时前` : `${(d / 60).toFixed(1)}h ago`;
}

export function localDateLabel(d: Date): string {
  return d.toLocaleDateString(runtimeLocale() === "zh" ? "zh-CN" : undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}

export function isSameLocalDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
